module.exports = __webpack_public_path__ + "static/img/1.82751b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/ovulation/1.png
// module id = 9cac
// module chunks = 1